import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {ShineAuthService} from './shine-auth.service';

/**
 * Route guard that uses the ShineAuthService for authentication.
 */
@Injectable({
    providedIn: 'root'
})
export class ShineAuthGuard implements CanActivate {
    private shineAuthService = inject(ShineAuthService);
    private router = inject(Router);


    canActivate(
        _route: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // Check if the user is authenticated
        if (this.shineAuthService.isAuthenticated()) {
            return true;
        }

        // If not authenticated, redirect to login page
        console.warn('User is not authenticated, redirecting to login page');
        return this.router.parseUrl('/login');
    }
}
